import { render } from "./vitals-type.vue?vue&type=template&id=13c4706e&scoped=true"
import script from "./vitals-type.vue?vue&type=script&lang=js"
export * from "./vitals-type.vue?vue&type=script&lang=js"

import "./vitals-type.vue?vue&type=style&index=0&id=13c4706e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c4706e"]])

export default __exports__